import { useMemo } from 'react'
import { useWindowSize, useMeasure } from "react-use";
import { AlertScrollArea } from './AlertScrollArea';

import { Content } from './styles'

export function AlertContent({ children, noScroll = false, noPadding = false, ...rest }) {
  const window = useWindowSize();
  const [ref, alert] = useMeasure();

  const alertHeight = useMemo(() => {
    const maxHeight = window.height * 0.9
    if (maxHeight.toFixed(0) === alert.height.toFixed(0)) return `${maxHeight}px`
    return 'fit-content'
  }, [window.height, alert.height])

  return (
    <Content ref={ref} {...rest}>
      <AlertScrollArea height={alertHeight} noScroll={noScroll} noPadding={noPadding}>
        {children}
      </AlertScrollArea>
    </Content>
  )
}
